import jwtDecode from 'jwt-decode';
import cookies from 'js-cookie';

export default function getInitialState() {
  const getFromToken = (token, name) => {
    if (token) {
      const decoded = jwtDecode(token, { complete: true });
      return decoded[name];
    }
    return null;
  }
  const token = cookies.get('token');
  const email = getFromToken(token, 'sub');

  const initialState = {
    auth: {
      email,
      isAuthenticated: !!token,
      isAuthenticating: false,
      isError: false,
      token,
    },
  };

  return initialState;
}


// WEBPACK FOOTER //
// ./src/getInitialState.js